import "core-js/modules/es.object.from-entries.js";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { Col, Overlay, Row, Tooltip } from 'react-bootstrap';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import chroma, { scale } from 'chroma-js';
import { createSVGElement } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var NS = 'http://www.w3.org/2000/svg';
export function TimeVisualization(_ref) {
  var isLoading = _ref.isLoading,
      data = _ref.data,
      isBirth = _ref.isBirth,
      yearAfter = _ref.yearAfter,
      yearBefore = _ref.yearBefore;
  var intl = useIntl();
  var styleLoading = {
    opacity: '50%'
  };

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      hoveredElementAndData = _useState2[0],
      setHoveredElementAndData = _useState2[1];

  var ref = useRef();
  var scheme = scale('YlOrRd');
  var maxRange = new Date().getFullYear() - 1850; // Maximum (theoretically) possible range

  var width = 500,
      height = 150;
  var widthTicks = width / 20,
      heightTicks = height / 6;
  var widthBar = (width - widthTicks) / maxRange;
  var maxHeightBar = height - heightTicks;
  var hasYearAfter = yearAfter != null,
      hasYearBefore = yearBefore != null;
  var yearMin = yearAfter != null ? yearAfter : Number.MIN_SAFE_INTEGER;
  var yearMax = yearBefore != null ? yearBefore : Number.MAX_SAFE_INTEGER;

  var isYearColored = function isYearColored(year) {
    return yearMin <= year && year <= yearMax;
  };

  var toBW = function toBW(color) {
    var _chroma$hsl = chroma(color).hsl(),
        _chroma$hsl2 = _slicedToArray(_chroma$hsl, 3),
        h = _chroma$hsl2[0],
        l = _chroma$hsl2[2];

    return chroma.hsl(h, 0, l);
  };

  var eventsRegistered = null;
  useEffect(function () {
    var div = ref.current;

    if (div) {
      var _div$getElementsByTag = div.getElementsByTagName('svg'),
          _div$getElementsByTag2 = _slicedToArray(_div$getElementsByTag, 1),
          svg = _div$getElementsByTag2[0];

      if (data) {
        svg.innerHTML = '';
      }

      if (data && data.length > 0) {
        var events = [];
        var values = Object.fromEntries(data.map(function (_ref2) {
          var name = _ref2.name,
              count = _ref2.count;
          var year = parseInt(name);
          return [year, {
            year: year,
            count: count
          }];
        }));
        var years = Object.values(values).map(function (_ref3) {
          var year = _ref3.year;
          return year;
        });
        var _ref4 = [Math.min.apply(Math, _toConsumableArray(years)), Math.max.apply(Math, _toConsumableArray(years))],
            minYear = _ref4[0],
            maxYear = _ref4[1];
        var totalYears = maxYear - minYear + 1;
        var maxCount = Math.max.apply(Math, _toConsumableArray(Object.values(values).map(function (_ref5) {
          var count = _ref5.count;
          return count;
        })));

        var colorForCount = function colorForCount(count) {
          return scheme(count / maxCount).hex();
        };

        var gTicks = createSVGElement('g');
        svg.append(gTicks);
        var gBars = createSVGElement('g');
        svg.append(gBars);
        var gFront = createSVGElement('g');
        svg.append(gFront);
        var offsetX = (width - (widthTicks + widthBar * totalYears)) / 2;

        var _loop = function _loop() {
          var i = year - minYear;

          if (values[year] !== undefined) {
            var currentData = values[year];
            var count = currentData.count;
            var h = maxHeightBar * count / maxCount;
            var color = colorForCount(count);
            var rect = createSVGElement('rect', {
              x: offsetX + widthTicks + widthBar * i,
              y: maxHeightBar - h,
              width: widthBar,
              height: h,
              fill: isYearColored(year) ? color : toBW(color),
              'class': 'cursor-pointer'
            });
            gBars.append(rect);

            if (eventsRegistered === null) {
              var handleEnter = function handleEnter() {
                return setHoveredElementAndData([rect, currentData]);
              };

              var handleLeave = function handleLeave() {
                return setHoveredElementAndData(null);
              };

              var localEvents = [[rect, 'mouseenter', handleEnter], [rect, 'mouseleave', handleLeave]];
              events.push.apply(events, localEvents);
            }
          }
        };

        for (var year = minYear; year <= maxYear; year++) {
          _loop();
        }

        var maxX = offsetX + widthTicks + totalYears * widthBar;
        gFront.append(createSVGElement('line', {
          x1: offsetX + widthTicks,
          y1: maxHeightBar,
          x2: maxX,
          y2: maxHeightBar,
          stroke: 'black',
          'stroke-width': 1
        }));
        var maxTicks = 5;
        var ticks = Math.min(maxTicks, maxCount + 1);
        var maxCountTick = Math.floor(maxCount / (ticks - 1)) * (ticks - 1);

        for (var i = 0; i < ticks; i++) {
          var currentCount = Math.round(maxCountTick * i / (ticks - 1));
          var y = maxHeightBar * (1 - currentCount / maxCount);

          if (i > 0) {
            gTicks.append(createSVGElement('line', {
              x1: offsetX + widthTicks,
              y1: y,
              x2: maxX,
              y2: y,
              stroke: '#d7d7d7',
              'stroke-width': 1
            }));
            var ticksMargin = 5;
            var text = createSVGElement('text', {
              x: offsetX + widthTicks - ticksMargin,
              y: y,
              'text-anchor': 'end',
              'dominant-baseline': 'middle',
              'font-family': 'monospace',
              'font-size': 10,
              'class': 'plot-tick'
            });
            text.append(intl.formatNumber(currentCount));
            gTicks.append(text);
          }
        }

        var yearsTicks = [];
        yearsTicks.push(minYear);

        if (totalYears >= 8) {
          yearsTicks.push(maxYear);
        }

        yearsTicks.forEach(function (year) {
          var textX = offsetX + widthTicks + (year - minYear) * widthBar;
          var textY = maxHeightBar + 5;
          var text = createSVGElement('text', {
            x: textX,
            y: textY,
            'text-anchor': 'end',
            'dominant-baseline': 'central',
            'transform': "rotate(-45, ".concat(textX, ", ").concat(textY, ")"),
            'font-family': 'monospace',
            'font-size': 10,
            'class': 'plot-tick'
          });
          text.append(year);
          gTicks.append(text);
        });

        if (eventsRegistered !== null) {
          eventsRegistered.forEach(function (_ref6) {
            var _ref7 = _slicedToArray(_ref6, 3),
                element = _ref7[0],
                type = _ref7[1],
                handler = _ref7[2];

            return element.removeEventListener(type, handler);
          });
        }

        events.forEach(function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 3),
              element = _ref9[0],
              type = _ref9[1],
              handler = _ref9[2];

          return element.addEventListener(type, handler);
        });
        eventsRegistered = events;
      }
    }
  }, [ref, data]);
  useEffect(function () {
    return function () {
      // Cleanupjean
      if (eventsRegistered !== null) {
        eventsRegistered.forEach(function (_ref10) {
          var _ref11 = _slicedToArray(_ref10, 3),
              element = _ref11[0],
              type = _ref11[1],
              handler = _ref11[2];

          return element.removeEventListener(type, handler);
        });
      }
    };
  }, []);
  var showTooltip = !isLoading && hoveredElementAndData !== null && data !== null;
  return /*#__PURE__*/_jsx(Row, {
    style: isLoading ? styleLoading : null,
    className: "mt-2",
    children: /*#__PURE__*/_jsxs(Col, {
      xs: 12,
      sm: {
        offset: 1,
        span: 10
      },
      md: {
        offset: 2,
        span: 8
      },
      children: [/*#__PURE__*/_jsxs("div", {
        className: "text-center",
        children: [/*#__PURE__*/_jsx("h4", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "statistics.year.title"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "statistics.year.subtitle"
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        ref: ref,
        className: "container-time",
        children: [/*#__PURE__*/_jsx("svg", {
          xmlns: NS,
          viewBox: "0 0 ".concat(width, " ").concat(height),
          className: ""
        }), showTooltip && /*#__PURE__*/_jsx(Overlay, {
          target: hoveredElementAndData[0],
          show: showTooltip,
          placement: "top",
          transition: false,
          children: function children(props) {
            var _hoveredElementAndDat = hoveredElementAndData[1],
                year = _hoveredElementAndDat.year,
                count = _hoveredElementAndDat.count;
            return /*#__PURE__*/_jsxs(Tooltip, _objectSpread(_objectSpread({
              id: "statistics-time-tooltip"
            }, props), {}, {
              children: [/*#__PURE__*/_jsx(FormattedMessage, {
                id: "statistics.year.year",
                values: {
                  year: year
                }
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
                id: isBirth ? 'statistics.year.n_births' : 'statistics.year.n_deaths',
                values: {
                  count: /*#__PURE__*/_jsx(FormattedNumber, {
                    value: count
                  }),
                  n: count
                }
              })]
            }));
          }
        })]
      })]
    })
  });
}
TimeVisualization.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired
  })),
  isBirth: PropTypes.bool.isRequired,
  yearAfter: PropTypes.number,
  yearBefore: PropTypes.number
};
TimeVisualization.defaultProps = {
  isLoading: false,
  yearAfter: null,
  yearBefore: null
};